var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid orcamento-form-page"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm.store.configuracaoCarregada ? _c('b-card', {
    staticClass: "orcamento-form-card"
  }, [_c('b-tabs', {
    staticClass: "orcamento-form-tabs",
    attrs: {
      "pills": "",
      "horizontal": _vm.windowWidth < 992,
      "vertical": _vm.windowWidth >= 992,
      "nav-wrapper-class": _vm.windowWidth >= 992 ? 'w-25' : 'w-100',
      "fill": ""
    }
  }, [_c('Cliente'), _vm.store.apresentarObjetoIdentificador ? _c('Objeto') : _vm._e(), _c('Produto'), _c('Faturamento'), _c('Informacoes')], 1)], 1) : _vm._e(), _vm.store.configuracaoCarregada ? _c('div', {
    staticClass: "card-footer orcamento-form-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveOrcamento ? _c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [_vm.store.currentTab !== 0 ? _c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-2",
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]) : _vm._e(), _vm.store.isUpdate && _vm.store.currentTab !== _vm.finalTabIndex ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold mr-4",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Próximo ")]) : _vm._e(), _c('button', {
    ref: "submit_novo_orcamento",
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.salvarOrcamento
    }
  }, [_vm._v(" Salvar ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('orcamento');
      }
    }
  }, [_vm._v(" Cancelar ")])])]) : _c('div', {
    staticClass: "orcamento-form-navigation"
  }, [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('orcamento');
      }
    }
  }, [_vm._v(" Cancelar ")])])])])]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };